module.exports = __webpack_public_path__ + "img/scene_16.ac4e6092.jpg";